import { ReactElement, useState } from 'react';

import { HorizontalTabs } from '@/components/tabs';

import { ActionMeetingTemplateEditor } from './ActionMeetingTemplateEditor';

const tabs = [
  {
    label: 'Meeting Template',
    component: <ActionMeetingTemplateEditor />,
  },
];

const ActionSettings = (): ReactElement => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <HorizontalTabs
      tabs={tabs}
      selectedTab={selectedTab}
      handleChange={handleChange}
    />
  );
};

export default ActionSettings;
